import React from 'react';
import { 
    Box, 
    Typography, 
    Paper,
    Button,
    Alert
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ContactPerson from '../../../../../components/onboardingForms/ContactPerson';

/**
 * Admins step for company onboarding
 */
export const AdminsStep = ({ 
    admins,
    setAdmins,
    userEmail,
    errors
}) => {
    // Add a new admin
    const handleAddAdmin = () => {
        const newAdminId = admins.length > 0 ? Math.max(...admins.map(a => a.id)) + 1 : 1;
        setAdmins([
            ...admins,
            { 
                id: newAdminId, 
                firstName: '', 
                lastName: '', 
                role: '',
                email: '',
                phone: '',
                isPrimary: false // No longer setting anyone as primary
            }
        ]);
    };

    // Delete an admin
    const handleDeleteAdmin = (id) => {
        setAdmins(admins.filter(admin => admin.id !== id));
    };

    // Update an admin's field
    const handleAdminChange = (id, field, value) => {
        setAdmins(admins.map(admin => 
            admin.id === id ? { ...admin, [field]: value } : admin
        ));
    };

    return (
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5">
                    Additional Company Admins
                </Typography>
                <Button 
                    variant="outlined" 
                    startIcon={<AddIcon />}
                    onClick={handleAddAdmin}
                >
                    Add Contact
                </Button>
            </Box>
            
            <Alert severity="info" sx={{ mb: 3 }}>
                You can add additional company contacts here. This step is optional.
            </Alert>
            
            {admins.length === 0 && (
                <Typography color="text.secondary" sx={{ my: 2 }}>
                    No additional contacts added yet. You can proceed without adding any, or add contacts to help manage your company.
                </Typography>
            )}
            
            {admins.map((admin) => (
                <ContactPerson
                    key={admin.id}
                    id={admin.id}
                    firstName={admin.firstName}
                    lastName={admin.lastName}
                    role={admin.role}
                    email={admin.email}
                    phone={admin.phone}
                    isPrimary={admin.isPrimary}
                    onDelete={handleDeleteAdmin}
                    onChange={handleAdminChange}
                />
            ))}
            
            {admins.length === 0 && (
                <Button 
                    variant="contained" 
                    startIcon={<AddIcon />}
                    onClick={handleAddAdmin}
                    sx={{ mt: 2 }}
                >
                    Add Secondary Contact
                </Button>
            )}
            
            {errors?.admins && (
                <Typography color="error" sx={{ mt: 2 }}>
                    {errors.admins}
                </Typography>
            )}
        </Paper>
    );
}; 